import throttle from "lodash/throttle";
import { useEffect } from "react";

export const useHitBottom = ({ fetch }: { fetch: () => void }) => {
    useEffect(() => {
        const callback = throttle(() => {
            if (
                window.innerHeight + window.scrollY + 100 >=
                document.body.offsetHeight
            ) {
                fetch();
            }
        }, 300);

        window.addEventListener("scroll", callback);

        return () => window.removeEventListener("scroll", callback);
    }, [fetch]);
};
